import { render, staticRenderFns } from "./WidgetProfile.vue?vue&type=template&id=d56b4a28"
import script from "./WidgetProfile.vue?vue&type=script&lang=js"
export * from "./WidgetProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports